import React, { useRef } from 'react';
import { DivFlexCenter, Container, DivTextAlignCenter, ImageHeader, Title, Subtitle, SubmitButton, SecondaryButton, DivFlexEnd, DivFlexStart, DivCenter, ContainerCenter, CircleButton, ImageReceipt } from '../../styles/styles';
import Logo from '../../assets/seclogoanimado.gif'
import PoweredBy from '../../assets/powered by@2x.png'
import { faGlobe, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import domtoimage from 'dom-to-image';
import { IAvulso, ICobranca } from '../../types/TicketInterface';
import moment from 'moment';

function Receipt() {
    const faPropIcon = faInstagram as IconProp;

    let downloadReceipt = () => {
        domtoimage.toPng(document.getElementById('printDiv')!, { quality: 1})
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = 'Recibo.png';
                link.href = dataUrl;
                link.click();
            });
    }

    let goToSite = () => {
        window.open('http://www.control2.com.br/');
    }

    let goToInstagram = () => {
        window.open('https://www.instagram.com/control2sistemas/');
    }

    var ticket = JSON.parse(localStorage.getItem('ticket')!) as IAvulso;
    var respostaPagamento = JSON.parse(localStorage.getItem('respostaPagamento')!);
    var cobranca = JSON.parse(localStorage.getItem('cobranca')!) as ICobranca;

    document.addEventListener("DOMContentLoaded", function(e) {
        document.getElementById('nomeEstacionamento')!.innerHTML += ' ' + ticket.regestacionamento.strnome;
        document.getElementById('codigoTicket')!.innerHTML += ' ' + ticket.strcodigo;
        document.getElementById('entradaTicket')!.innerHTML += ' ' + moment.utc(ticket.datentrada).format('DD/MM/YYYY HH:mm:ss');
        document.getElementById('pagamentoTicket')!.innerHTML += ' ' + localStorage.getItem('dataPagamento');
        document.getElementById('limiteSaidaTicket')!.innerHTML += ' ' + moment.utc(respostaPagamento.datsaidapospgto).format('DD/MM/YYYY HH:mm:ss');
        document.getElementById('permanenciaTicket')!.innerHTML += ' ' + moment().startOf('day').add(respostaPagamento.lngPermanencia, 'minutes').format('HH:mm')
        document.getElementById('valorPagoTicket')!.innerHTML += ' R$ ' + cobranca.douValorCobrado.toFixed(2).toString().replace('.', ',');
    });

    return (
        <>
            <DivCenter>
                <ContainerCenter>

                    <DivFlexEnd className='mt-3'>
                        <CircleButton onClick={downloadReceipt} style={{ width: '2.5em', height: '2.5em', backgroundColor: '#FFF', color: '#CE6B00' }}>
                            <span>
                                <FontAwesomeIcon icon={faDownload as IconProp} />
                            </span>
                        </CircleButton>
                    </DivFlexEnd>

                    <Container id='printDiv' className='mt-2 mb-2'>
                        <div>
                            <Title style={{ fontFamily: 'Lemon Milk', color: '#CE6B00' }}>
                                COMPROVANTE
                            </Title>

                            <ImageReceipt src={Logo} />
                        </div>

                        <br />

                        <Subtitle>
                            Estabelecimento
                        </Subtitle>
                        <br />
                        <label id='nomeEstacionamento' className='text-muted'>
                        </label>

                        <hr />

                        <Subtitle>
                            Horário
                        </Subtitle>
                        <br />
                        <label id='entradaTicket' className='text-muted'>
                            Entrada:
                        </label>
                        <br />
                        <label id='pagamentoTicket' className='text-muted'>
                            Pagamento:
                        </label>
                        <br />
                        <label id='limiteSaidaTicket' className='text-muted'>
                            Limite de saída:
                        </label>
                        <br />
                        <label id='permanenciaTicket' className='text-muted'>
                            Permanência total:
                        </label>

                        <hr />

                        <Subtitle id='codigoTicket' style={{ fontWeight: 'normal' }}>
                            Ticket:
                        </Subtitle>

                        <br />

                        <Title style={{ color: '#444242', fontSize: '1.25em' }} id='valorPagoTicket'>
                            VALOR PAGO:
                        </Title>

                        <hr />

                        <CircleButton onClick={goToSite} className='mt-2' style={{ width: '2.5em', height: '2.5em', display: 'inline-block', float: 'left' }}>
                            <span>
                                <FontAwesomeIcon icon={faGlobe as IconProp} />
                            </span>
                        </CircleButton>

                        <CircleButton onClick={goToInstagram} className='ml-2 mt-2 mb-3' style={{ width: '2.5em', height: '2.5em', display: 'inline-block' }}>
                            <span>
                                <FontAwesomeIcon icon={faPropIcon} />
                            </span>
                        </CircleButton>

                        <img className='mb-3' style={{ float: 'right', width: '124px', height: '64px', display: 'inline-block' }} src={PoweredBy} />

                    </Container>
                </ContainerCenter>

            </DivCenter>
        </>
    );
}

export default Receipt;